import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";
import EDEStatementsEnrollmentAgreementPage, { getDefaultPageUI } from "components/EDEStatements/pages/EDEStatementsEnrollmentAgreementPage";

/**
 * @name CaptureEDEStatementsEnrollmentAgreement
 * @returns {React.Component}
 * @description A capture in the "EDE eStatement Enrollment" capture group.
 */
export default function CaptureEDEStatementsEnrollmentAgreement(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "scrollBar", "isActive" ], true)
    .submit();

    return <EDEStatementsEnrollmentAgreementPage ui={ ui } />
}